import { Injectable } from '@angular/core';
import { AddArticleLabelModalComponent } from '../../modals/add-article-label-modal/add-article-label-modal.component';
import { AddEditRoundLabelModalComponent } from '../../modals/add-edit-round-label-modal/add-edit-round-label-modal.component';
import { EditLabelModalComponent } from '../../../labels-printer/edit-label-modal/edit-label-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ArticleEtikettenModalsService {
  add?: AddArticleLabelModalComponent;
  round?: AddEditRoundLabelModalComponent;
  ownBrand?: EditLabelModalComponent;

  private refreshFn?: () => void;

  register(refs: {
    add: AddArticleLabelModalComponent;
    round: AddEditRoundLabelModalComponent;
    ownBrand: EditLabelModalComponent;
  }): void {
    this.add = refs.add;
    this.round = refs.round;
    this.ownBrand = refs.ownBrand;
  }

  unregister(): void {
    this.add = undefined;
    this.round = undefined;
    this.ownBrand = undefined;
  }

  setRefresh(fn?: () => void): void {
    this.refreshFn = fn;
  }

  refreshList(): void {
    this.refreshFn?.();
  }
}
